import { render, staticRenderFns } from "./EditInvoice.vue?vue&type=template&id=5540064d&"
import script from "./EditInvoice.vue?vue&type=script&lang=ts&"
export * from "./EditInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./EditInvoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports